// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideZoomIn as RawLucideZoomIn } from "lucide-react";
export const LucideZoomIn = /* @__PURE__ */ createIcon(RawLucideZoomIn, "LucideZoomIn", 2);
